export const API_BASE = (() => {
  const host = typeof window !== 'undefined' ? window.location.hostname : '';

  if (host === 'localhost' || host === '127.0.0.1') {
    return 'http://localhost:3001';
  }

  return process.env.REACT_APP_API_BASE || 'https://frolik-backend.onrender.com';
})();

async function request(path, options = {}) {
  const res = await fetch(`${API_BASE}${path}`, {
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
    ...options,
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    return { error: data.error || 'Request failed', botCheck: Boolean(data.botCheck) };
  }

  return data;
}

const api = {
  register(payload) {
    return request('/api/auth/register', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  },

  login(payload) {
    return request('/api/auth/login', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  },

  logout() {
    localStorage.removeItem('auth_user');
    localStorage.removeItem('auth_token');
    return Promise.resolve({ ok: true });
  },
};

export const register = api.register;
export const login = api.login;
export const logout = api.logout;

export default api;